type ENV = {
  env: 'development' | 'production'
  baseUrl: string
  goEasyIosApkUrl: string
  goEasyCommonApkUrl: string
  goEasyYouqianqianbaoApkUrl: string
  goEasyRongyihuaApkUrl: string

  customerHotline: string
  customerQrcode: string

  incomeBaseUrl: string
  incomeBasePath: string

  navigateToMallUrl: string
}

const env: ENV = {
  env: import.meta.env.VITE_ENV as ENV['env'],
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  
  goEasyIosApkUrl: import.meta.env.VITE_GO_EASY_IOS_APK_URL,
  goEasyCommonApkUrl: import.meta.env.VITE_GO_EASY_COMMON_APK_URL,
  goEasyYouqianqianbaoApkUrl: import.meta.env.VITE_GO_EASY_YOUQIANQIANBAO_APK_URL,
  goEasyRongyihuaApkUrl: import.meta.env.VITE_GO_EASY_RONGYIHUA_APK_URL,

  customerHotline: import.meta.env.VITE_GO_EASY_CUSTOMER_HOTLINE,
  customerQrcode: import.meta.env.VITE_GO_EASY_CUSTOMER_QRCODE,

  incomeBaseUrl: import.meta.env.VITE_INCOME_BASE_URL,
  incomeBasePath: import.meta.env.VITE_INCOME_BASE_PATH,

  navigateToMallUrl: import.meta.env.VITE_NAVIGATE_MALL_URL,
  
}

console.log({ env })

export default env